import { Loading, StatusTagBudgetControl } from 'components';
import { TableBudgetControl } from 'components/TableBudgetControl';
import { demandStatusLabels, demandStatusVariant } from 'constants/demands';
import { useBoolean } from 'hooks/useBoolean';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { getBudgetControlStatusList, IGetBudgetControlStatusList } from 'services/budgetControl';
import { formatCurrency } from 'utils/number';
import * as Styles from './styles';

interface IProps {
  history: RouteComponentProps['history'];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const statuses = [
  'Pendente: Sua demanda já foi cadastrada e está aguardando aprovação da sua empresa',
  'Não iniciada: A sua demanda já foi aprovada e será iniciada em breve',
  'Em curso: Sua demanda já está sendo realizada',
  'Finalizada: Sua demanda já foi entregue',
  'Cancelada: A sua demanda foi cancelada',
];

const StatusControlComponent: React.FC<IProps> = ({ history }) => {
  const [isLoading, toggleIsLoading] = useBoolean(false);
  const [statusList, setStatusList] = useState<IGetBudgetControlStatusList[]>([]);
  const handleGetStatus = useCallback(async (query?: string) => {
    try {
      toggleIsLoading(true);

      const response = await getBudgetControlStatusList(query || '');
      toggleIsLoading(false);
      setStatusList(response.data);
    } catch (error) {
      toggleIsLoading(false);
    }
  }, []);

  useEffect(() => {
    handleGetStatus();

    const removeListen = history.listen(location => handleGetStatus(location.search));

    return () => {
      removeListen();
    };
  }, []);

  return (
    <Styles.Container>
      <legend>Controle por status</legend>
      {isLoading ? (
        <Loading />
      ) : (
        <TableBudgetControl
          row={[0]}
          headers={['Status', 'Serviços', 'Valores totais']}
          sizes={[3, 2, 2]}
          rows={statusList.map(status => [
            <StatusTagBudgetControl
              maxWidth="70%"
              isFlex
              key="status"
              variant={demandStatusVariant[status.status]}
            >
              {demandStatusLabels[status.status]}
            </StatusTagBudgetControl>,
            status.servicos,
            formatCurrency(status.total),
          ])}
        />
      )}
    </Styles.Container>
  );
};

export const StatusControl = memo(StatusControlComponent);
